goog.provide('missionary.Cancelled');

/**
 * @param {string} message
 * @constructor
 */
missionary.Cancelled = function(message) {
  'use strict';

  /**
   * The error message.
   * @const {string}
   */
  this.message = message;

};
